import * as tokens from '../styles/tokens'

import type { Theme } from './lightTheme'

// Conforming to Theme keeps the two themes' keys from drifting apart
const theme: Theme = {
  primary: tokens.primary,
  background: tokens.surfaceDark,
  text: tokens.onSurfaceDark,
  labelText: tokens.onSurfaceVariantDark,
  border: tokens.outlineDark,
  offset: tokens.surfaceDimDark,
  hover: tokens.surfaceBrightHoverDark,
  banner: tokens.surfaceDisabledDark,
  highlight: tokens.primary,
  mutedText: tokens.onSurfaceMutedDark,
  invertedText: tokens.onSurfaceDarkContrast,
  disabledText: tokens.onSurfaceDisabledDark,
  linkText: tokens.primary,
  surfaceDim: tokens.surfaceDisabledDark,
  hairline: tokens.hairlineDark,
  rowHover: tokens.rowHoverBackgroundDark,
  mainMenu: {
    background: tokens.mainMenuBackgroundDark,
  },
  dialog: {
    background: tokens.dialogBackgroundDark,
  },
  syntax: tokens.syntaxDark,
}

export default theme
